if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

$(window).on('load', function () {
    $(window).scrollTop(0);
    setTimeout(function () {
        $('.mv_catch, .mv_logo').addClass('fade-in');
    }, 200);

    // 暗転解除直前に背景動画を再生開始
    setTimeout(function () {
        document.querySelectorAll('.mv_movie_video').forEach(function (video) {
            video.play().catch(function () {});
        });
        $('.loader').fadeOut(800, function () {
            $('.site_header').addClass('fade-in');

            // 別ページから /#hash で来た場合は、初期演出（loader）完了後にアンカーへスムーススクロール
            if (location.hash && location.hash.startsWith('#')) {
                var id = location.hash.slice(1);
                var targetElement = document.getElementById(id);
                if (targetElement && typeof smoothScrollToY === 'function') {
                    // レイアウト確定待ち（画像/フォント読み込み直後のズレを軽減）
                    setTimeout(function () {
                        var rectTop = targetElement.getBoundingClientRect().top;
                        var offsetY = window.pageYOffset || 0;
                        var gap = 0;
                        var targetY = rectTop + offsetY - gap;
                        smoothScrollToY(targetY, 1100);
                    }, 50);
                }
            }
        });
    }, 1800);
});


const mvSwiper = new Swiper('.mv_slider .swiper', {
    effect: 'fade', // フェードモード
    fadeEffect: {
        crossFade: true,
    },
    loop: true,
    speed: 500, // スライドアニメーションのスピード
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        waitForTransition: false,
    },
    on: {
        slideChangeTransitionStart: function () {
            // ホワイトアウト開始
            document.querySelector('.mv_slider').classList.add('fade-effect');

            // すべての画像をスケール 1.2 に戻す
            document.querySelectorAll('.mv_slider .swiper-slide img').forEach(img => {
                img.style.transform = 'scale(1.1)';
            });

            // 新しいスライドを 1.0 に縮小
            const activeSlide = document.querySelector('.mv_slider .swiper-slide-active img');
            if (activeSlide) {
                activeSlide.style.transform = 'scale(1.0)';
            }
        },
        slideChangeTransitionEnd: function () {
            // ホワイトアウト解除
            setTimeout(() => {
                document.querySelector('.mv_slider').classList.remove('fade-effect');
            }, 300);
        }
    }
});

// .site_topbar(40px) を除いた高さを .mv#lh-box に指定（SP/PC 共通・リサイズ・縦横切り替えにも対応）
function setLhBoxHeight() {
  var vh = window.innerHeight - 40;
  var lhBox = document.getElementById('lh-box');
  if (lhBox) lhBox.style.height = vh + 'px';
}
$(function () {
  setLhBoxHeight();
});
$(window).on('load', function () {
  setLhBoxHeight();
});
$(window).on('resize orientationchange', function () {
  setLhBoxHeight();
});